export function isNonEmptyString(s) {
  return typeof s === 'string' && s.length > 0
}
